/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * The video element has been removed from DOM while initializing.
 */
export class VideoDestroyedError extends Error {
  static NAME = 'VideoDestroyed';

  /**
   * Constructor
   *
   * @param {string} message Error message
   * @param {...any} args    Other arguments
   */
  constructor(message = 'The video element has been removed from DOM.', ...args) {
    super(...arguments);

    this.name = this.constructor.NAME;
  }
}
